/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_AddInputs */

const vi_grower_area_add = /** @type {(inputs: Grower_Area_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm vùng`)
};

/**

* @param {Grower_Area_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_add = /** @type {((inputs?: Grower_Area_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_add(inputs)
});